import React from 'react';

const Home = () => (
  <div>
    <h1>Welcome to Our Page</h1>
    <p className="home-detail">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Laudantium omnis,
      qui accusamus inventore consequatur ex alias quas? Praesentium asperiores
      molestiae sequi alias esse totam maiores obcaecati amet, consectetur vitae
      blanditiis. Beatae vel velit rem! Earum nesciunt perspiciatis odio, rerum
      nulla ab doloremque officia ducimus quod minus vel, sunt iste, omnis
      beatae amet iusto et non. Corporis pariatur inventore eius nisi!
      Consectetur iusto accusantium harum nobis sed error atque unde at aut
      doloribus, culpa, veritatis cumque, natus ipsa suscipit sequi sint sunt
      earum. or quas repellendus vero odio natus ut, tempore possimus eum quod
      sint.
    </p>
    <p className="home-detail">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta vel
      possimus sint voluptatibus unde. Hic, dignissimos praesentium veniam,
      error consectetur sint dolores eum ipsa distinctio cumque repellendus est
      modi nihil! Quisquam aliquid fuga hic voluptates perferendis quam minus
      exercitationem possimus tempore nostrum animi fugiat consequuntur repellat
      quia maiores, dolorem corporis cumque! Harum eaque repellat nam, natus
      aliquid vel ipsa sunt? Adipisci sint vitae minima eum. Eveniet dolorum
      alias aspernatur unde distinctio ducimus? Illo, nobis. Repellendus ducimus
      ipsam voluptatem, nobis eligendi necessitatibus autem optio veniam?
      Consectetur expedita ab error laboriosam ea. Odio eum aliquam magnam
      exercitationem sint deleniti eaque.
    </p>
  </div>
);

export default Home;
